export default __webpack_public_path__ + "static/media/android-s4.dbe1d8ca.webp";